module.exports = __webpack_public_path__ + "img/voucher_icon_2.31e1ccc0.svg";